// extracted by mini-css-extract-plugin
export default {"historyModal":"PublicHistoryModal_historyModal__hJwpo","title":"PublicHistoryModal_title__s+ZMS","content":"PublicHistoryModal_content__MXXtH"};